import {
  type CreateMessagePayload,
  CreateTicketPayload,
  PaginatedResponse,
  SupportMessage,
  SupportTicketDetail,
  SupportTicketSummary,
} from "../interfaces";
import { apiClient } from "./client";

export type TicketStatus = "OPEN" | "IN_PROGRESS" | "RESOLVED";
export type TicketPriority = "LOW" | "MEDIUM" | "HIGH";
export type TicketCategory = "BUG" | "INTEGRATION" | "BILLING" | "OTHER";

export const supportApi = {
  getMyTickets: (page: number = 0, size: number = 20) =>
    apiClient.get<PaginatedResponse<SupportTicketSummary>>(
      `/support/tickets?page=${page}&size=${size}`,
    ),

  getTicketDetails: (ticketId: string) =>
    apiClient.get<SupportTicketDetail>(`/support/tickets/${ticketId}`),

  createTicket: (payload: CreateTicketPayload) =>
    apiClient.post<SupportTicketSummary>("/support/tickets", payload),

  addReply: (ticketId: string, payload: CreateMessagePayload) =>
    apiClient.post<SupportMessage>(
      `/support/tickets/${ticketId}/messages`,
      payload,
    ),
  getUnreadCount: () =>
    apiClient.get<{ count: number }>("/support/tickets/unread-count"),
  markAsRead: (ticketId: string) =>
    apiClient.post<void>(`/support/tickets/${ticketId}/mark-as-read`, {}),

  uploadAttachment: (ticketId: string, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.postForm<any>(
      `/support/tickets/${ticketId}/attachments`,
      formData,
    );
  },

  downloadAttachment: async (
    ticketId: string,
    attachmentId: string,
    filename: string,
  ) => {
    const blob = await apiClient.download(
      `/support/tickets/${ticketId}/attachments/${attachmentId}`,
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },

  deleteAttachment: (ticketId: string, attachmentId: string) =>
    apiClient.delete<void>(
      `/support/tickets/${ticketId}/attachments/${attachmentId}`,
    ),
};

export { CreateMessagePayload };
export type { CreateTicketPayload };
